import { createSlice } from '@reduxjs/toolkit';
import { userSelectors } from 'reducers';

const initialState = {
    errors: {},
    currentInvestmentFund: { id: 0, name: '', type: '' },
    changesVerifier: null, // custom function that checks for changes on a tunnel step form
    submitHandler: null, // custom function that submits the current tunnel step form
    validationHandler: null, // custom function that runs form validation on a tunnel step
    ineligible: {
        open: false,
        message: '',
        subMessage: '',
        abandon: true,
        hasDialogActions: true,
    },
    showCodeVerifier: false,
};

const tunnel = createSlice({
    name: 'tunnel',
    initialState,
    reducers: {
        tunnelErrorsSet(state, action) {
            if (Array.isArray(action.payload)) {
                state.errors = Object.fromEntries(action.payload.map(e => [e.property, e.message]));
            }
        },
        codeVerifierSet(state, action) {
            state.showCodeVerifier = action.payload;
        },
        ineligibleSet(state, action) {
            state.ineligible = action.payload;
        },
        submitHandlerSet(state, action) {
            state.submitHandler = action.payload;
        },
        formChangesVerifierSet(state, action) {
            state.changesVerifier = action.payload;
        },
        validationHandlerSet(state, action) {
            state.validationHandler = action.payload;
        },
        currentInvestmentFundSet(state, action) {
            state.currentInvestmentFund = action.payload;
        },
    },
});

export const {
    tunnelErrorsSet,
    codeVerifierSet,
    ineligibleSet,
    submitHandlerSet,
    formChangesVerifierSet,
    validationHandlerSet,
    currentInvestmentFundSet,
} = tunnel.actions;

// Selectors
const getInvestmentFundName = state => {
    const tunnelSubscription = userSelectors.getTunnelSubscription(state);
    return tunnelSubscription?.investmentFund?.name || '';
};

const getCurrentInvestmentFund = state => {
    const tunnelSubscription = userSelectors.getTunnelSubscription(state);
    return (
        tunnelSubscription?.investmentFund ||
        state.tunnel.currentInvestmentFund || { id: 0, name: '', type: '' }
    );
};

export const selectors = {
    getInvestmentFundName,
    getTunnelErrors: state => state.tunnel.errors,
    getIneligibleStatus: state => state.tunnel.ineligible,
    getShowCodeVerifier: state => state.tunnel.showCodeVerifier,
    getSubmitHandler: state => state.tunnel.submitHandler,
    getFormChangesVerifier: state => state.tunnel.changesVerifier,
    getValidationHandler: state => state.tunnel.validationHandler,
    getCurrentInvestmentFund,
};

export default tunnel.reducer;
